module.exports = __webpack_public_path__ + "img/PVCOMBANK.3ee358d7.png";